module.exports = __webpack_public_path__ + "img/arrow-minimal.afc09a54.svg";